export default {
  namespaced: true,
  state: {
    type: [
      { name: '未選択', value: '未選択' },
      { name: 'admin', value: 'admin' },
      { name: 'owner', value: 'owner' },
      { name: 'mgr', value: 'mgr' },
      { name: 'staff', value: 'staff' },
      { name: 'act', value: 'act' },
      { name: 'accounting', value: 'accounting' }
    ],

    hide_flag: [
      { name: '稼働中', value: 0 },
      { name: '削除', value: 1 }
    ],

    office: [
      { name: '未選択', value: '未選択' },
      { name: '仙台', value: '仙台' },
      { name: '札幌', value: '札幌' },
      { name: '名古屋', value: '名古屋' },
      { name: '福岡', value: '福岡' },
      { name: '新宿', value: '新宿' },
      { name: '高松', value: '高松' },
      { name: '大宮', value: '大宮' },
      { name: '高崎', value: '高崎' },
      { name: '東京', value: '東京' }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    type (state) { return state.type },
    hide_flag (state) { return state.hide_flag },
    office (state) { return state.office }
  }
}



// WEBPACK FOOTER //
// ./src/store/users.js